import React from 'react'
import { Link } from 'react-router-dom'
import Tooltip from '@mui/material/Tooltip';
const AnnouncementsAndNews = () => {
  return (
    <div>
       <div className="d-flex gap-16 align-items-center">
        <span>
          <img src="/assets/images/admin-panel/announcement/megaphone.svg" className="img-fluid" alt="" />
        </span>
        <div className="">
          <div className="d-flex gap-10 text-black align-items-center fw-bold font-m font-36"> 
             {/* <Tooltip title="Go Back" arrow placement="top">
      <Link
        to="/"
        className="w-32-px h-32-px radius-8 object-fit-cover d-flex justify-content-center align-items-center fw-semibold text-xs bg-neutral-900 text-white"
      >
        <iconify-icon icon="line-md:arrow-small-left" width="24" height="24"></iconify-icon>
      </Link> 
    </Tooltip>*/}
            Announcements Overview 
          </div>
          <p>informed about platform updates, upcoming features, policy changes, events, and other important information</p>
        </div>
      </div>
    </div>
  )
}

export default AnnouncementsAndNews
